export const formatIban = (payload: string): string => {
  payload = payload.split(' ').join('')
  let iban = ''
  for (let i = 0; i < payload.length; i++) {
    if (i % 4 === 0) {
      iban = iban + ' '
    }
    iban = iban + payload.charAt(i)
  }
  return iban.trim().toUpperCase()
}
